import React from 'react';
import '../../../styles/irctcAboutInfo.css';
import { getAppEnv } from '../../../../config/env';
import PropTypes from 'prop-types';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const CapchaInfo = ({ customClass }) => {
  return (
    <div className={`${customClass} aboutContainer`}>
      Captcha is a combination of English alphabets (case sensitive) and numbers that is required for a successful IRCTC
      Login.
      <br />
      If needed, you can reset the Captcha without reloading the IRCTC Login page by clicking on the reload button next
      to Captcha field.
      <br />A typical Captcha field looks like the following-
      <div className="imgWrap__captcha">
        <img src={`${PUBLIC_URL}/static/public/badCaptcha.png`} alt={''} />
      </div>
      <span>
        <b>Please note:</b> The above image is for reference only. You will receive a different set of letters as
        Captcha.
      </span>
    </div>
  );
};

CapchaInfo.propTypes = {
  customClass: PropTypes.string
};

export default CapchaInfo;
